export const FOR_MANUAL_INPUT = "for_manual_input";
export const FOR_UTM_SOURCE = "for_utm_source";
export const FOR_LANDING = "for_landing";

export const SOURCE_TYPE = [
  {label: "относится к источникам ручного ввода", value: FOR_MANUAL_INPUT},
  {label: "utm метка", value: FOR_UTM_SOURCE},
  {label: "лендинг", value: FOR_LANDING},
];